var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.205 251.561C269.43 232.57 296 193.504 296 148C296 84.031 243.969 32 180 32H140C76.031 32 24 84.031 24 148C24 193.504 50.57 232.57 88.795 251.561C37.975 263.879 0 309.443 0 364C0 427.969 52.031 480 116 480H204C267.969 480 320 427.969 320 364C320 309.443 282.025 263.879 231.205 251.561ZM40 148C40 92.875 84.875 48 140 48H180C235.125 48 280 92.875 280 148S235.125 248 180 248H140C84.875 248 40 203.125 40 148ZM204 464H116C60.875 464 16 419.125 16 364S60.875 264 116 264H204C259.125 264 304 308.875 304 364S259.125 464 204 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.3957119ec328c0f0cb0e0773c23c88ce.svg";
export { ForwardRef as ReactComponent };